import { SVGProps } from 'react';

const Pencil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15 5 4 4m2.174-2.188a2.819 2.819 0 1 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83L2.02 21.356a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
    />
  </svg>
);
export default Pencil;
